module.exports = __webpack_public_path__ + "static/media/05-MGM_Casino_Fish_Restaurant.03cc3a15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mgm-casino/05-MGM_Casino_Fish_Restaurant.jpg
// module id = 1190
// module chunks = 37